import {
  ArrowUpRight
} from "lucide-react";
import { Link } from "react-router";

import type {
  Category
} from "../../types/catalog";
import {
  categoryImageUrl
} from "../../utils/category-image";

interface CategoryCardProps {
  category: Category;
  compact?: boolean;
}

const fallbackTones = [
  "from-[#c7a484] to-[#765747]",
  "from-[#9d7b69] to-[#514035]",
  "from-[#9f6c7a] to-[#633e4a]",
  "from-[#a2a47c] to-[#59614a]",
  "from-[#c29477] to-[#755342]"
];

export function CategoryCard({
  category,
  compact = false
}: CategoryCardProps) {
  const tone =
    fallbackTones[
      category.name.length %
      fallbackTones.length
    ];

  return (
    <Link
      to={`/shop?category=${encodeURIComponent(
        category.slug
      )}`}
      className="group relative block overflow-hidden rounded-[2rem] bg-[#eee5da]"
    >
      <div
        className={
          compact
            ? "aspect-[4/3]"
            : "aspect-[5/4]"
        }
      >
        {category.imageKey ? (
          <img
            src={categoryImageUrl(
              category.id
            )}
            alt={`${category.name} collection`}
            className="h-full w-full object-cover transition duration-700 group-hover:scale-[1.04]"
            loading="lazy"
          />
        ) : (
          <div
            className={`flex h-full items-center justify-center bg-gradient-to-br ${tone}`}
          >
            <span className="font-serif text-4xl text-white/90">
              RiNi
            </span>
          </div>
        )}

        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />

        <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 p-6 text-white">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white/75">
              Explore collection
            </p>

            <h3 className="mt-2 font-serif text-2xl font-semibold">
              {category.name}
            </h3>

            {!compact &&
              category.description && (
                <p className="mt-2 line-clamp-2 max-w-sm text-sm leading-6 text-white/80">
                  {category.description}
                </p>
              )}
          </div>

          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white text-[#5e3b2c] transition group-hover:-translate-y-1 group-hover:translate-x-1">
            <ArrowUpRight
              size={19}
            />
          </span>
        </div>
      </div>
    </Link>
  );
}
